"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toInt = void 0;
const assertString_1 = require("./util/assertString");
function toInt(str, radix) {
    (0, assertString_1.assertString)(str);
    return parseInt(str, radix || 10);
}
exports.toInt = toInt;
